/* Ha-upplausn forskodunarmyndir ur ljosmyndum kunnans (gull, silfur, svart, hvitt -
   ferhyrnt og sporoskjulaga, med og an ramma). Til ad fyrsta heimsokn se snogg:
   webp fra Shopify CDN, preload a theirri mynd sem birtist strax,
   og hin efnin forhladin i bakgrunni eftir ad sidan er komin i ro.

   Breiddin raest af skjanum. Myndin er 3x2 tafla af afbrigdum, svo hver reitur
   er einn thridji af breiddinni. I sima er skiltid litid og 1080 duga vel, tha
   er reiturinn 360 px. A tolvu er skiltid margfalt staerra og 1080 gefa grofa,
   upptrekkta mynd; 2400 er full upplausn frummyndarinnar og gefur 800 px reit.
   Siminn heldur 1080 svo fyrsta heimsokn se afram snogg. */
(function(){
  var root=document.querySelector('[data-hurda]'); if(!root) return;
  var B='https://cdn.shopify.com/s/files/1/0612/3818/1973/files/';
  var Q='?v=1788060051&width='+(window.innerWidth>1000?2400:1080)+'&format=webp';
  var A={
    'data-atlas-rect-silver':'sm-atlas-rect-grey-v4.jpg',
    'data-atlas-oval-silver':'sm-atlas-oval-grey-v4.jpg',
    'data-atlas-rect-gold':'sm-atlas-rect-gold-v4.jpg',
    'data-atlas-oval-gold':'sm-atlas-oval-gold-v4.jpg',
    'data-atlas-rect-black':'sm-atlas-rect-black-v4.jpg',
    'data-atlas-oval-black':'sm-atlas-oval-black-v4.jpg',
    'data-atlas-rect-white':'sm-atlas-rect-white-v4.jpg',
    'data-atlas-oval-white':'sm-atlas-oval-white-v4.jpg'
  };
  var urls=[];
  Object.keys(A).forEach(function(k){ var u=B+A[k]+Q; root.setAttribute(k,u); urls.push(u); });

  /* Myndin sem birtist fyrst faeður forgang */
  var img=root.querySelector('[data-plate-img]');
  if(img){ try{ img.setAttribute('fetchpriority','high'); img.setAttribute('decoding','async'); }catch(e){} }
  var first=root.getAttribute('data-atlas-rect-silver');
  try{
    var l=document.createElement('link');
    l.rel='preload'; l.as='image'; l.href=first; l.setAttribute('fetchpriority','high');
    document.head.appendChild(l);
  }catch(e){}

  function repaint(){ try{ window.dispatchEvent(new Event('resize')); }catch(e){} }
  repaint();

  /* Hin efnin: adeins eftir ad sidan er hladin, i rolegheitum */
  function prefetch(){
    urls.forEach(function(u,i){ setTimeout(function(){ var im=new Image(); im.decoding='async'; im.src=u; }, i*400); });
  }
  function later(){ if('requestIdleCallback' in window) requestIdleCallback(prefetch,{timeout:4000}); else setTimeout(prefetch,2500); }
  if(document.readyState==='complete') later(); else window.addEventListener('load',later);

  /* Sporoskjulaga: letrid orlitid staerra.
     ATH: EKKI skrifa inline font-size her - tha hlaupa tveir utreikningar
     a mot hvor odrum og textinn titrar. Setjum bara klasa; CSS staekkar
     stafina um 9% (sm-mat-info.css). */
  var t=root.querySelector('[data-plate-text]');
  var ovalBtn=root.querySelector('[data-toggle-oval]');
  function sync(){
    if(!t) return;
    var on=!!(ovalBtn&&ovalBtn.classList.contains('on'));
    if(t.classList.contains('oval-bump')!==on) t.classList.toggle('oval-bump',on);
  }
  sync();
  if(ovalBtn&&window.MutationObserver){
    new MutationObserver(sync).observe(ovalBtn,{attributes:true,attributeFilter:['class']});
  }
  root.querySelectorAll('[data-toggle-oval],[data-mat],[data-size],[data-font]').forEach(function(b){
    b.addEventListener('click',function(){ setTimeout(sync,60); setTimeout(sync,300); });
  });
  [200,800,2000].forEach(function(x){ setTimeout(function(){ repaint(); sync(); },x); });
})();
